// extracted by mini-css-extract-plugin
export default {"linkText":"Maintainers_linkText__rdACX"};